import { getApiBaseUrl, handleApiError } from '../../../core/config/api';

export class BaseUserService {
  protected getAuthToken(): string | null {
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    return token;
  }

  protected async fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
    const token = this.getAuthToken();
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(options.headers as Record<string, string> || {}),
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    return fetch(url, {
      ...options,
      headers,
    });
  }

  protected getApiBase(): string {
    return getApiBaseUrl(true);
  }

  protected handleError(error: any): never {
    throw new Error(handleApiError(error));
  }
}
